import React from 'react';
import {TextField} from "../TextField/TextField";

export const MultilineTextField = (props) => {
    return <TextField {...props} multiline rows={5} />
}